import { JobPosition } from '../../../domain/graphcms';
import { slugIt } from '../../utils/links';
import { sendEvent } from './tracking';

export function createJobApplicationEventLabel(element: string, jobPosition: JobPosition, province?: string) {
  return [
    element,
    jobPosition.department,
    jobPosition.name,
    province,
  ].filter((value) => !!value)
    .map((value) => slugIt(value))
    .join(':');
}

export function sendJobApplicationEvent(eventLabel: string) {
  sendEvent(
    'job_application_submit',
    {
      category: 'job-application',
      action: 'submit',
      label: eventLabel,
    },
  );
}
